<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-row>
        <v-col cols="12" md="6">
          <v-card
              class="ml-3 mr-3" outlined
          >
            <v-card-title>
              Edit Group
            </v-card-title>
            <hr class="ma-1">
            <div class="col">
              <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
              >
                <v-text-field
                    v-model="group.name"
                    :rules="nameRules"
                    label="Name"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="group.description"
                    label="Description"
                ></v-text-field>

                <v-text-field
                    v-model="group.subdomain"
                    label="Subdomain"
                >
                  <v-card-text slot="append">.wallet.sg</v-card-text>
                </v-text-field>

                <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mt-4 mr-4 mt-4 font-weight-bold"
                    @click="submit"
                >
                  Save
                </v-btn>
              </v-form>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-row class="mt-0">
            <v-col cols="12" class="pt-0">
              <v-card class="ml-3 mr-3" outlined>
                <v-card-title>Outlets</v-card-title>
                <hr class="ma-1">
                <v-list>
                  <v-list-item
                      v-for="outlet in outlets"
                      :key="outlet.id"
                      @click="manageOutlet(outlet.id)"
                      link>
                    <v-list-item-icon>
                      <v-icon>mdi-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-html="outlet.name"></v-list-item-title>
                      <v-list-item-subtitle v-html="outlet.description"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-card class="ml-3 mr-3" outlined>
                <v-card-title>Admins</v-card-title>
                <hr class="ma-1">
                <v-list>
                  <v-list-item
                      v-for="admin in admins"
                      :key="admin.id"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-html="admin.name"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: true,
    nameRules: [
      v => !!v || 'Name is required',
    ],
    // subdomainRules: [
    //     v => !!v || 'Sub-domain is required',
    // ],
    breadcrumbsItems: '',
  }),
  props: ['group', 'outlets', 'admins'],
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        axios.post('/group/' + this.group.id, {
          name: this.group.name,
          description: this.group.description,
          subdomain: this.group.subdomain,
        }).then(function (result) {
          window.location.href = '/superadmin';
        });
      }
    },
    manageOutlet(oid) {
      window.location.href = '/outlet/' + oid + '/edit'
    },
  },
  beforeMount() {
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.group.name,
      },
    ];
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Groups/GroupEdit.vue